// src/config/constants.js
export const ROUTE_PATHS = {
  HOME: "/",
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  USERS: "/users",
};

export const ROLES = {
  ADMIN: "ADMIN",
  USER: "USER",
};
